// extracted by mini-css-extract-plugin
export var active = "_ax-7";
export var container = "_ax-0";
export var evenWidth = "_ax-4";
export var large = "_ax-5";
export var outlet = "_ax-8";
export var slide = "_ax-2";
export var small = "_ax-6";
export var tab = "_ax-3";
export var tabs = "_ax-1";